<template>
	<div class="navigate"></div>
</template>

<script>
export default {
	name: "Navigate"
}
</script>

<style scoped>
</style>